export const schemaName = 'targetRanges'
